<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <!-- <Toast position="bottom-right" /> -->

        <h4>
          List of Customers
          <FilterName :currentFilter="savedFilter" />
        </h4>
        <Toolbar class="p-mb-4">
          <template slot="left">
            <span class="p-input-icon-left mb-2">
              <div class="p-inputgroup">
                <Button
                  icon="pi pi-fw pi-refresh"
                  class="p-mr-1"
                  @click="setupComponentData(1)"
                />
                <Button
                  icon="pi pi-fw pi-cog"
                  class="p-mr-1"
                  @click="openColumnsSelection()"
                />
                <InputText
                  v-model="searchText"
                  placeholder="Global Search"
                  @input="updateSearch"
                />
                <Button
                  icon="pi pi-times p-pr-1"
                  class="p-mr-1"
                  @click="closeSearch"
                />
                <div
                  :class="getClassForQuickFiltersDiv()"
                  :key="quickFiltersDivKey"
                >
                  <Button
                    style="width: 50px; top: 50%; transform: translate(0%, -50%);"
                    @click="
                      quickFilterDialog = true;
                      quickFilterDialogKey++;
                    "
                    icon="pi pi-filter"
                    :class="
                      'p-button-rounded ' + getClassForQuickFiltersButon()
                    "
                    :badge="getBadgeForQuickFilters().toString()"
                  />
                  <Button
                    v-if="isEmpty()"
                    @click="clearQuickFilter()"
                    icon="pi pi-times"
                    :class="
                      'p-button-rounded ' + getClassForQuickFiltersButon()
                    "
                  />
                </div>
              </div>
            </span>
          </template>
          <template slot="right">
            <div class="p-input-icon-left">
              <Button
                style="height: 36px;"
                @click="makeFavorite()"
                :icon="favorite ? 'pi pi-star' : 'pi pi-star-o'"
                class="p-mr-1 p-button-text p-button-danger mb-2"
                :disabled="
                  !(savedFilter && savedFilter.id) || favoriteRequesting
                "
              />
              <Dropdown
                v-model="savedFilter"
                :options="savedFilters"
                optionLabel="filterName"
                dataKey="id"
                placeholder="Select Saved Filter"
                :showClear="true"
                class="mb-2"
                style="width: 200px;"
              >
                <template #option="slotProps">
                  {{ slotProps.option.filterName }}
                </template>
              </Dropdown>
              <Button
                style="height: 36px;"
                @click="editSelectedFilter()"
                icon="pi pi-pencil"
                class="p-mx-1 mb-2"
                :disabled="!(savedFilter && savedFilter.id)"
              />
              <Button
                style="height: 36px;"
                @click="deleteSavedFilterWarning = true"
                icon="pi pi-trash"
                class="p-mr-1 p-button-danger mb-2"
                :disabled="!(savedFilter && savedFilter.id)"
              />
              <Button
                label="New filter"
                icon="pi pi-plus"
                class="p-button-success p-mt-1 mb-2"
                @click="newFilter()"
              />
              <Button
                label="New Customer"
                icon="pi pi-plus"
                class="p-button-success p-mr-2 ml-2 mt-1 mb-2"
                style="margin-right: 1em"
                @click="openNew"
              />
            </div>
          </template>
        </Toolbar>
      </div>
    </div>

    <Dialog
      :key="quickFilterDialogKey"
      :visible.sync="quickFilterDialog"
      :style="{ width: '500px', overflowY: 'auto' }"
      header="Quick Filters"
      :modal="true"
      class="p-fluid"
    >
      <div v-for="(element, index) in dbViewFieldsForQuickFilters" :key="index">
        <div v-if="element.quickFilter === true" class="p-formgrid p-grid">
          <div class="p-field p-col p-d-flex">
            <label class="p-as-center" :for="element.fieldName">
              {{ element.fieldName }}
            </label>
          </div>
          <div class="p-field p-col">
            <div v-if="isQuickFilterable(index)">
              <div v-if="getFieldType(index) === 'Date'" style="width: 250px;">
                <Dropdown
                  :showClear="true"
                  v-model="quickFiltersSelection[index]"
                  :options="getOptions(index)"
                  optionLabel="dateModifierName"
                  dataKey="id"
                  placeholder="Select from the dropdown"
                  style="width: 100%"
                />
                <div class="pt-1">
                  <InputMask
                    v-if="showDateRanges(index)"
                    mask="99/99/9999"
                    v-model="datesFrom[index]"
                    slotChar="dd/mm/yyyy"
                    placeholder="Date from"
                    style="width: 49%;"
                  />
                  <InputMask
                    v-if="showDateRanges(index)"
                    mask="99/99/9999"
                    v-model="datesTo[index]"
                    slotChar="dd/mm/yyyy"
                    placeholder="Date to"
                    style="width: 49%; float: right;"
                  />
                </div>
              </div>
              <div
                v-else-if="getFieldType(index) === 'Currency'"
                style="width: 250px;"
              >
                £
                <InputNumber
                  v-model="datesFrom[index]"
                  placeholder="From"
                  style="width: 45%;"
                />
                £
                <InputNumber
                  v-model="datesTo[index]"
                  placeholder="To"
                  style="width: 45%; float: right;"
                />
              </div>
              <div
                v-else-if="getFieldType(index) === 'Number'"
                style="width: 250px;"
              >
                <InputNumber
                  v-model="datesFrom[index]"
                  placeholder="From"
                  style="width: 49%;"
                />
                <InputNumber
                  v-model="datesTo[index]"
                  placeholder="To"
                  style="width: 49%; float: right;"
                />
              </div>
              <div
                v-else-if="getFieldType(index) === 'Yes/No'"
                style="width: 250px;"
              >
                <Dropdown
                  :showClear="true"
                  v-model="quickFiltersSelection[index]"
                  :options="getOptions(index)"
                  :optionLabel="getOptionLabel(element, index)"
                  :dataKey="getDataKey(element)"
                  placeholder="Select from the dropdown"
                  style="width: 100%"
                />
              </div>
              <div v-else style="width: 250px">
                <MultiSelect
                  filter
                  v-model="quickFiltersSelection[index]"
                  :options="getOptions(index)"
                  :optionLabel="getOptionLabel(element, index)"
                  :dataKey="getDataKey(element)"
                  placeholder="Type to display options"
                  style="width: 100%"
                >
                  <template #emptyfilter>
                    <div>No results found</div>
                  </template>
                </MultiSelect>
              </div>
            </div>
            <ProgressSpinner
              v-else
              style="width:30px; height:30px"
              strokeWidth="2"
              fill="#EEEEEE"
              animationDuration=".5s"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          style="float: left;"
          label="Clear All Filters"
          icon="pi pi-times"
          class="p-button-danger"
          @click="clearQuickFilter()"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-info"
          style="width: 100px;"
          @click="quickFilterDialog = false"
        />
        <Button
          label="Apply Filters"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 130px;"
          @click="setupQuickFilter()"
        />
      </template>
    </Dialog>

    <Dialog header="Header" :visible.sync="deleteSavedFilterWarning">
      <template #header>
        <h3>Delete Alert</h3>
      </template>

      Are you sure you want to delete this filter?

      <template #footer>
        <Button
          @click="deleteSavedFilterWarning = false"
          label="No"
          icon="pi pi-times"
          class="p-button-success"
          style="width: 80px;"
        />
        <ProgressSpinner
          v-if="deleteRequesting"
          style="width:25px; height:25px; width: 80px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          @click="deleteSavedFilter()"
          label="Yes"
          icon="pi pi-check"
          autofocus
          class="p-button-danger"
          style="width: 80px;"
        />
      </template>
    </Dialog>

    <ProgressSpinner
      v-if="firstRequesting"
      style="width:50px; height:50px;"
      strokeWidth="5"
      fill="#EEEEEE"
      animationDuration=".5s"
    />
    <div v-else style="width: 100%;">
      <component
        :is="tableComponent"
        :data="customers"
        :dbView="dbView"
        :loading="loading"
        :dbViewFields="dbViewFields"
        :colSelectedFields="colSelectedFields"
        :colSelectedFieldsForTable="colSelectedFieldsForTable"
        :totalRecords="totalRecords"
        :rows="rows"
        :currentPage="currentPage"
        :reloadTable="realoadLazyTable"
        :customerNames="customerNames"
        @reload="reload"
        @editCustomer="editCustomer"
        @lazyNext="lazyNext"
        @sortChange="sortChange"
        @colSaved="colSaved()"
        @colUpdated="colUpdated"
        @customerForApproval="openCustomerForApproval"
        :makingExport="makingExport"
        @exportData="exportData"
      />
    </div>

    <ColumnSelection
      :columnSelectionDialog="columnSelectionDialog"
      :dbView="dbView"
      :dbViewFields="dbViewFields"
      :selectionToEdit="colSelectedFields"
      :reloadComponent="reloadColumnSelectionComponent"
      :resettingColumns="resettingColumns"
      @close="columnSelectionDialog = false"
      @colSaved="colSaved()"
      @resetCols="resetCols"
    />

    <FilterForm
      v-if="filterFormDialog"
      :filterForm="filterFormDialog"
      :getDBViewFieldsId="dbView"
      :filterToEdit="filterToEdit"
      @close="filterFormDialog = false"
      @saved="filterSaved()"
    />

    <component
      :is="formComponent"
      :customerToEdit="customer"
      :customerDialog="customerDialog"
      :disabledArr="disabledArr"
      @close="customerDialog = false"
      @saved="saved"
      @customerForApproval="openCustomerForApproval"
    />

    <duplicateTable
      v-if="displayDuplicateMessage"
      :duplicateDialog="displayDuplicateMessage"
      :dataId="'customerId'"
      :name="'Customer'"
      :namePlural="'Customers'"
      :list="duplicates"
      :requesting="duplicateRequesting"
      @close="displayDuplicateMessage = false"
      @agree="sendDuplicate()"
    />

    <Dialog
      header="Select a customer"
      :visible.sync="assignToCustomerDialog"
      :style="{ width: '400px', height: '400px' }"
      :modal="true"
    >
      <div class="p-formgrid p-grid" style="height: 227px;">
        <div class="p-field p-col">
          <CustomDropDown
            :allOptions="customerNames"
            :disabled="false"
            optionLabel="custName"
            dataKey="customerId"
            :forceSelection="true"
            :showDropDownOnStart="true"
            :currentValue="customerForApproval"
            placeholder="Select Customer"
            style="width: 100%"
            @selected="setCustomerForApproval"
            :inputClass="{
              'p-invalid':
                submitted &&
                !(customerForApproval && customerForApproval.customerId)
            }"
          />
          <small
            class="p-invalid"
            v-if="
              submitted &&
                !(customerForApproval && customerForApproval.customerId)
            "
            >Customer is required.</small
          >
        </div>
      </div>
      <h6>NOTE: This action can’t be reversed.</h6>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          @click="assignToCustomerDialog = false"
          class="p-button-text p-button-danger"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Assign"
          icon="pi pi-check"
          @click="assignCustomer()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";
import FiltersService from "@/service/FiltersSerice";

import CustomerDataTableForLazy from "../universalComponents/customer/CustomersDataTableForLazyWithResize";
import ColumnSelection from "../universalComponents/columnSelection/ColumnSelection";
import FilterName from "../universalComponents/general/filterName";
import FilterForm from "../universalComponents/filter/filterForm";
import customerForm from "../universalComponents/customer/customerForm";
import duplicateTable from "../universalComponents/customer/duplicateDialog";

import moment from "moment";

import { customerConf } from "../universalComponents/sendRequest";
import PermissionMixin from "../PermissionMixin.vue";

import ListViewStateMixin from "../ListViewStateMixin.vue";
import { savedFilterChanged } from "../savedFilterChanged.js";

export default {
  // Vuex module holding this list's persisted filter/sort/page/scroll state.
  listViewModule: "customers",
  components: {
    CustomerDataTableForLazy,
    ColumnSelection,
    FilterForm,
    customerForm,
    duplicateTable,
    FilterName
  },
  mixins: [PermissionMixin, ListViewStateMixin],
  created() {
    this.customerService
      .getCustomerNames()
      .then(data => (this.customerNames = data))
      .catch(error => {
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "customernames"'
        });
      });

    this.setupComponent();
    this.setupFieldPermissions();
  },
  data: () => ({
    customerService: new CustomerService(),
    filtersService: new FiltersService(),
    keyContactIncludedInNonAllowFields: false,
    dbView: 6, // 6 for customer
    filterFormDialog: false,
    savedFilters: null,
    savedFilter: null,
    customers: [], // For whole data set
    customer: {},
    customerDialog: false,
    displayDuplicateMessage: false,
    duplicateInfo: {},
    messages: [],
    dbViewFields: [],
    dbViewFieldsForQuickFilters: [],
    quickFiltersSelection: [],
    datesFrom: [],
    datesTo: [],
    quickFiltersOptions: [],
    tableKey1: 0,
    disabledArr: [],
    columnSelectionDialog: false,
    defaultView: true,
    colSelectedFields: [],
    colSelectedFieldsForTable: [],
    requesting: false,
    tableKey1: 0,
    realoadLazyTable1: 0,
    deleteSavedFilterWarning: false,
    quickFilterDialogKey1: 0,
    quickFilterDialog: false,
    filterToEdit: {},
    duplicates: [],
    displayDuplicateMessage: false,
    quickFiltersDivKey1: 0,
    reloadColumnSelectionComponent: 0,
    resettingColumns: false,
    deleteRequesting: false,
    favoriteRequesting: false,
    favorite: false,
    open: true,
    searchText: "",
    totalRecords: null,
    totalPages: null,
    currentPage: 1,
    rows: 25,
    sortField: "",
    sortFieldId: 0,
    sortOrder: 0,
    lastMainRequestBody: {},
    lastMainRequest: "",
    firstRequesting: true,
    forceReload: false,
    duplicateRequesting: false,

    sendingRequest: false,
    submitted: false,
    assignToCustomerDialog: false,
    customerNames: [],
    customerForApproval: {},
    selectedRow: {},

    makingExport: false
  }),
  computed: {
    myPermissions() {
      return this.$store.getters["auth/getUserPermissions"];
    },
    hardLoad() {
      return this.listViewGet("getHardLoad");
    },
    softReload() {
      return this.listViewGet("getSoftReload");
    },
    realoadLazyTable: {
      set() {
        this.tableKey1++;
      },
      get() {
        return "realoadLazyTable-" + this.tableKey1.toString();
      }
    },
    loading() {
      //
      if (this.customers && this.customers[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    },
    tableComponent() {
      return this.firstRequesting === false ? CustomerDataTableForLazy : null;
    },
    formComponent() {
      return this.firstRequesting === false || this.customerDialog
        ? customerForm
        : null;
    },
    quickFilterDialogKey: {
      set() {
        this.quickFilterDialogKey1++;
      },
      get() {
        return "quickFilterDialogKey-" + this.quickFilterDialogKey1.toString();
      }
    },
    quickFiltersDivKey: {
      set(val) {
        this.quickFiltersDivKey1++;
      },
      get() {
        return "quickFiltersDivKey" + this.quickFiltersDivKey1.toString();
      }
    }
  },
  watch: {
    myPermissions(val) {
      if (val && val[0]) {
        this.setupFieldPermissions();
      }
    },
    currentPage(val) {
      //
      this.listViewSet("setPage", {
        page: val,
        rows: this.listViewGet("getRows")
      });

      if (val === 1) {
        this.realoadLazyTable++;
      }
    },
    hardLoad(val) {
      //

      this.setupComponentData(1);
    },
    softReload(val) {
      //

      this.setupComponentData(0);
    },
    colSelectedFields(val) {
      this.$store.dispatch(`commons/columnsSelection${this.dbView}`, val);
      this.setupColumns();
    },
    colSelectedFieldsForTable(val) {
      //
      this.realoadLazyTable++;
      // setTimeout(() => this.colSelectedFieldsForTable.forEach(a =>
    },
    savedFilter(val) {
      if (val && (val.favourite !== null || val.favourite !== undefined)) {
        this.favorite = val.favourite;
      }

      let oldFilter = this.listViewGet("getMainListSavedFilter");

      this.listViewSet("setMainListSavedFilter", val);

      if (savedFilterChanged(oldFilter, val)) {
        this.currentPage = 1;
      }

      this.getDataFromSource();
    },
    dbViewFieldsForQuickFilters(val) {
      //
      if (
        !this.quickFiltersSelection.every(
          element => element === undefined || element === null
        )
      ) {
        this.getDataFromSource();
      }
    },
    dbViewFields(val) {
      this.setupViewFieldsForQuickFilters();

      //
      if (this.colSelectedFieldsForTable.length < 1) {
        this.colSelectedFieldsForTable = val.filter(a => a.defView);
      }
      // this.colSelectedFieldsForTable.forEach(a =>
    },
    quickFiltersSelection(val) {
      this.listViewSet("setMainListQuickFilters", val);
    },
    datesFrom(val) {
      this.listViewSet("setQuickFiltersDatesFrom", val);
    },
    datesTo(val) {
      this.listViewSet("setQuickFiltersDatesTo", val);
    }
  },
  methods: {
    setupFieldPermissions() {
      this.disabledArr = [];
      let permission = this.myPermissions.find(
        a => a.permission.permissionCode === "EditCustFields"
      );
      if (permission) {
        if (permission.permissionLevel === 2) {
          {
            this.disabledArr.push(...permission.permission.fields.split(","));
            if (this.disabledArr.includes("keyContact"))
              this.keyContactIncludedInNonAllowFields = true;
          }
        } else if (permission.permissionLevel === 0) {
          this.disabledArr = [
            "custName",
            "address1",
            "address2",
            "address3",
            "address4",
            "postCode",
            "customerType",
            "phoneNo",
            "mobile",
            "email",
            "mainNotes",
            "showMsg",
            "tag",
            "website",
            "mainEmail",
            "faxNo",
            "salesExec",
            "parentFlag",
            "region",
            "keyContact",
            "custCode",
            "parentCustomer"
          ];
        } else if (permission.permissionLevel === 3) {
          this.disabledArr = [];
        }
        this.open = false;
      }
    },
    makeFavorite() {
      this.favorite = !this.favorite;

      this.favoriteRequesting = true;
      this.filtersService
        .setSavedFilterFav(this.savedFilter.id, this.favorite ? 1 : 0)
        .then(data => {
          let filterIndex = this.savedFilters.findIndex(
            filter => filter.id === this.savedFilter.id
          );
          if (filterIndex >= 0) {
            this.savedFilters[filterIndex].favourite = this.favorite;
          }
          this.favoriteRequesting = false;
        })
        .catch(error => {
          this.favoriteRequesting = false;
          this.favorite = !this.favorite;

          this.$toast.add({
            severity: "error",
            summary: "Can't change favorite...",
            detail: "Error while changing favorite status of this filter.",
            life: 5000
          });
        });
    },
    resetCols() {
      this.resettingColumns = true;

      this.filtersService
        .resetColumns(this.dbView)
        .then(data => {
          this.resettingColumns = false;
          this.columnSelectionDialog = false;
          this.colSelectedFields = data;
          this.getDBViewFields();
        })
        .catch(error => {
          this.resettingColumns = false;
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error while reseting columns`,
            life: 5000
          });
        });
    },
    colUpdated(obj) {
      if (obj) {
        var id = obj.id,
          width = obj.width;
        //
        let a = this.colSelectedFields.findIndex(b => b.id === id);
        if (a >= 0 && this.colSelectedFields[a]) {
          this.colSelectedFields[a].width = width;
        }
      }
    },
    setupComponent() {
      this.firstRequesting = true;

      // setTimeout(() => {
      //
      //   if (!this.forceReload) {
      let a = this.listViewGet("getFirstTimeLoad");

      if (a) {
        this.listViewSet("setFirstTimeLoad", false);
        this.setupComponentData(1);
      } else {
        this.setupComponentData(0);
      }
      //   }
      // }, 50)

      this.getUserViewFilters();

      this.getColumnSelection();

      this.getDBViewFields();
    },
    setupComponentData(hardLoad) {
      if (hardLoad) {
        this.forceReload = true;

        // setup sort

        this.sortField = "";
        this.sortFieldId = 0;
        this.sortOrder = 0;
        this.listViewSet("setSort", {
          sortField: this.sortField,
          sortFieldId: this.sortFieldId,
          sortOrder: this.sortOrder
        });

        // setup page and rows

        this.rows = 25;
        this.currentPage = 1;
        this.listViewSet("setPage", {
          page: this.currentPage,
          rows: this.rows
        });

        this.realoadLazyTable++;

        // setup search

        this.searchText = "";
        this.syncSearchToUrl("");

        // A hard load is a deliberate reset, so drop the stored scroll offset
        // too - otherwise the reset list would jump back down the page.
        this.persistScrollY(0);
        this.persistGridScrollY(0);

        // setup quick filters

        this.quickFiltersSelection = [];
        this.datesFrom = [];
        this.datesTo = [];
        this.listViewSet("setMainListQuickFilters",
          this.quickFiltersSelection
        );
        this.listViewSet("setQuickFiltersDatesFrom",
          this.datesFrom
        );
        this.listViewSet("setQuickFiltersDatesTo", this.datesTo);

        // setup savedfilter

        this.getDefUserViewFilter()
          .then(savedFilter => {
            if (!savedFilter) {
              this.getDataFromSource();
            } else {
              this.savedFilter = savedFilter;
            }
          })
          .catch(err => {
            this.getDataFromSource();
          });
      } else {
        // setup sort

        if (this.listViewGet("getSortField")) {
          this.sortField = this.listViewGet("getSortField");
          this.sortFieldId = this.listViewGet("getSortFieldId");
          this.sortOrder = this.listViewGet("getSortOrder");
        }

        // setup page and rows

        this.rows = this.listViewGet("getRows");
        this.currentPage = this.listViewGet("getPage");

        // setup search

        this.searchText = this.$route.query.search || this.listViewGet("getSearchText") || "";

        // setup quick filters

        this.quickFiltersSelection = [
          ...this.listViewGet("getMainListQuickFilter")
        ];
        this.datesFrom = [
          ...this.listViewGet("getQuickFiltersDatesFrom")
        ];
        this.datesTo = [
          ...this.listViewGet("getQuickFiltersDatesTo")
        ];

        // setup savedfilter

        this.savedFilter = {
          ...this.listViewGet("getMainListSavedFilter")
        };

        // Re-entering the list, so put the user back where they were. This
        // waits for the lazy grid to render before scrolling.
        this.restoreListScroll();
      }
    },
    getDataFromSource() {
      let savedFilter1 = 0,
        quickFilters = {};

      if (this.savedFilter && this.savedFilter.id) {
        savedFilter1 = this.savedFilter.id;
      }

      var cancelRequest = false;

      //

      if (
        !(
          this.quickFiltersSelection.every(
            element => element === undefined || element === null
          ) &&
          this.datesFrom.every(
            element => element === undefined || element === null
          ) &&
          this.datesTo.every(
            element => element === undefined || element === null
          )
        )
      ) {
        if (this.dbViewFieldsForQuickFilters.length) {
          for (let i = 0; i < this.dbViewFieldsForQuickFilters.length; i++) {
            try {
              if (this.dbViewFieldsForQuickFilters[i].quickFilter) {
                //

                let a = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(0)[0];
                let b = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(-1)[0];

                if (this.quickFiltersSelection[i]) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Date"
                  ) {
                    //

                    if (
                      this.quickFiltersSelection[i].dateModifierFunc ===
                      "custom"
                    ) {
                      //
                      if (this.datesFrom[i]) {
                        try {
                          quickFilters[`${a}From`] = moment(
                            this.datesFrom[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}From`] = this.datesFrom[i];
                        }
                      }
                      if (this.datesTo[i]) {
                        try {
                          quickFilters[`${a}To`] = moment(
                            this.datesTo[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}To`] = this.datesTo[i];
                        }
                      }
                    } else {
                      quickFilters[a] = this.quickFiltersSelection[
                        i
                      ].dateModifierFunc;
                    }
                  } else {
                    if (this.quickFiltersSelection[i][b] === "Yes") {
                      quickFilters[a] = true;
                    } else if (this.quickFiltersSelection[i][b] === "No") {
                      quickFilters[a] = false;
                    } else if (
                      this.dbViewFieldsForQuickFilters[i].lovEP &&
                      this.dbViewFieldsForQuickFilters[i].lovEP.substr(0, 1) ===
                        "*"
                    ) {
                      if (this.quickFiltersSelection[i].length > 1) {
                        quickFilters[a] = this.quickFiltersSelection[i]
                          .map(item => {
                            return item[b];
                          })
                          .join(",");
                      } else {
                        quickFilters[a] = this.quickFiltersSelection[i][0][b];
                      }
                    } else {
                      if (typeof this.quickFiltersSelection[i] === "string") {
                        quickFilters[a] = this.quickFiltersSelection[i];
                      } else {
                        if (this.quickFiltersSelection[i]?.length > 0)
                          quickFilters[a] = this.quickFiltersSelection[i]
                            .map(item => {
                              return item[
                                this.dbViewFieldsForQuickFilters[i].dbIdField
                              ];
                            })
                            .join(",");
                      }
                    }
                  }
                } else if (
                  !(
                    this.datesFrom[i] === undefined ||
                    this.datesFrom[i] === null ||
                    this.datesTo[i] === undefined ||
                    this.datesTo[i] === null
                  )
                ) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType ===
                      "Currency" ||
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Number"
                  ) {
                    quickFilters[`${a}From`] = this.datesFrom[i];
                    quickFilters[`${a}To`] = this.datesTo[i];
                  }
                }
              }
            } catch (e) {
              continue;
            }
          }
        } else {
          cancelRequest = true;
        }
      }

      var thisMainRequestBody = JSON.stringify(quickFilters);

      let searchQuery = "*";
      if (this.searchText) {
        searchQuery = this.searchText;
      }

      var thisRequest = `${savedFilter1}/${this.currentPage}/${this.rows}/${this.sortFieldId}/${this.sortOrder}/${searchQuery}`;

      if (!cancelRequest) {
        if (
          !(
            thisRequest === this.lastMainRequest &&
            thisMainRequestBody === this.lastMainRequestBody
          ) ||
          this.forceReload
        ) {
          this.forceReload = false;

          this.lastMainRequest = thisRequest;
          this.lastMainRequestBody = thisMainRequestBody;

          this.requesting = true;
          this.customers = [];

          quickFilters.searchText = searchQuery;

          this.customerService
            .getCustomers2(
              savedFilter1,
              this.currentPage,
              this.rows,
              this.sortFieldId,
              this.sortOrder,
              "*",
              quickFilters
            )
            .then(response => {
              //

              let responseData = JSON.parse(response.config.data),
                a = response.config.url.split("/");

              a[8] = responseData.searchText;

              let b = a.map(c => parseInt(c));

              delete responseData.searchText;
              responseData = JSON.stringify(responseData);

              if (
                a[8] === "*" &&
                this.searchText === "" &&
                b[3] === savedFilter1 &&
                b[4] === this.currentPage &&
                b[5] === this.rows &&
                b[6] === this.sortFieldId &&
                b[7] === this.sortOrder &&
                responseData &&
                responseData === this.lastMainRequestBody
              ) {
                this.requesting = false;
                this.firstRequesting = false;

                this.totalRecords = parseInt(response.headers.reccount);
                this.customers = response.data;
              } else if (
                b[3] === savedFilter1 &&
                b[4] === this.currentPage &&
                b[5] === this.rows &&
                b[6] === this.sortFieldId &&
                b[7] === this.sortOrder &&
                a[8] === this.searchText &&
                responseData &&
                responseData === this.lastMainRequestBody
              ) {
                this.requesting = false;
                this.firstRequesting = false;

                this.totalRecords = parseInt(response.headers.reccount);
                this.customers = response.data;
              }
            })
            .catch(err => {
              this.requesting = false;

              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: `Error while getting customer for saved filter ${savedFilter1} and search text ${this.searchText}`,
                life: 5000
              });
            });
        }
      }
    },
    sortChange({ sortField, sortFieldId, sortOrder }) {
      this.listViewSet("setSort", {
        sortField,
        sortFieldId,
        sortOrder
      });

      this.sortField = sortField;
      this.sortFieldId = sortFieldId;
      this.sortOrder = sortOrder;

      if (this.currentPage !== 1) {
        this.currentPage = 1;
      }

      this.getDataFromSource();
    },
    lazyNext({ page, rows, totalPages }) {
      this.listViewSet("setPage", { page, rows });

      this.rows = rows;
      this.totalPages = totalPages;
      if (this.currentPage !== page) {
        this.currentPage = page;
      }

      this.getDataFromSource();
    },
    setupQuickFilter() {
      this.quickFilterDialog = false;
      //
      this.listViewSet("setMainListQuickFilters",
        this.quickFiltersSelection
      );
      this.listViewSet("setQuickFiltersDatesFrom",
        this.datesFrom
      );
      this.listViewSet("setQuickFiltersDatesTo", this.datesTo);

      this.getDataFromSource();
    },
    closeSearch() {
      this.searchText = "";
      this.syncSearchToUrl("");

      this.getDataFromSource();
    },
    updateSearch(e) {
      this.searchText = e;
      this.syncSearchToUrl(e);

      this.getDataFromSource();
    },
    checkExistanceOfFilterFldId(quickFilterOptionsList, index) {
      try {
        if (
          quickFilterOptionsList.length > 0 &&
          index &&
          this.dbViewFields[index] &&
          this.dbViewFields[index].filterDefId
        ) {
          if (index == 27) {
            let permission = this.myPermissions.find(
              a => a.permission.permissionCode === "ViewCustomers"
            );

            if (permission) {
              if (permission.permissionLevel == 4) {
                // global user
                this.quickFiltersSelection[index] = [
                  quickFilterOptionsList.find(
                    a =>
                      a[this.dbViewFields[index].dbIdField] ===
                      this.dbViewFields[index].filterDefId
                  )
                ];
              }
            }
          } else if (index == 2) {
            let permission = this.myPermissions.find(
              a => a.permission.permissionCode === "ViewCustomers"
            );
            var branch = this.$store.getters["auth/getMyProfile"].defBranch;
            if (permission) {
              if (permission.permissionLevel == 5) {
                if (branch) this.quickFiltersSelection[index] = branch;
              } else {
                this.quickFiltersSelection[index] = quickFilterOptionsList.find(
                  a =>
                    a[this.dbViewFields[index].dbIdField] ===
                    this.dbViewFields[index].filterDefId
                );
              }
            }
          } else {
            this.quickFiltersSelection[index] = quickFilterOptionsList.find(
              a =>
                a[this.dbViewFields[index].dbIdField] ===
                this.dbViewFields[index].filterDefId
            );
          }
        }
      } catch (e) {}
    },
    async setupViewFieldsForQuickFilters() {
      var duplicateDate = [];

      this.dbViewFields.forEach(d => {
        // if (d.fieldName === "Start Date") {
        //   duplicateDate.push({...d, dbField: "startDateFrom", fieldName: "Start Date From"})
        //   duplicateDate.push({...d, id: d.id + '1', dbField: "startDateTo", fieldName: "Start Date To"})

        // } else {
        duplicateDate.push(d);
        // }
      });

      this.dbViewFieldsForQuickFilters = [];

      var notExists = this.quickFiltersSelection.every(
        element => element === undefined || element === null
      );

      //

      for (let index = 0; index < duplicateDate.length; index++) {
        let d = duplicateDate[index];
        this.dbViewFieldsForQuickFilters.push(d);

        //

        if (d.quickFilter) {
          if (d.fieldType === "Date") {
            this.filtersService
              .getDateModifiers()
              .then(data => {
                this.quickFiltersOptions[index] = data;
                this.checkExistanceOfFilterFldId(
                  this.quickFiltersOptions[index],
                  index
                );
              })
              .catch(err => {
                this.$store.dispatch("addErrorMessage", {
                  severity: "error",
                  content: 'Some data was not loaded from "dateModifiers"'
                });
              });
          } else if (d.lovEP) {
            //
            if (d.lovEP === "YES/NO") {
              this.quickFiltersOptions[index] = [
                { id: 1, [d.dbField]: "Yes" },
                { id: 2, [d.dbField]: "No" }
              ];
              this.checkExistanceOfFilterFldId(
                this.quickFiltersOptions[index],
                index
              );
            } else if (d.lovEP.substr(0, 1) === "*") {
              let list = d.lovEP.substr(1).split("/");
              if (list.length) {
                this.quickFiltersOptions[index] = list.map((a, index) => {
                  return { id: index, [d.dbField]: a };
                });
                this.checkExistanceOfFilterFldId(
                  this.quickFiltersOptions[index],
                  index
                );
              }
            } else {
              try {
                this.quickFiltersOptions[
                  index
                ] = await this.filtersService.filtersCustomRequest(d.lovEP);
                await this.checkExistanceOfFilterFldId(
                  this.quickFiltersOptions[index],
                  index
                );
              } catch (err) {
                if (err && err.response && err.response.status !== 200) {
                  this.$store.dispatch("addErrorMessage", {
                    severity: "error",
                    content: `Some data was not loaded from "${d.lovEP}"`
                  });
                }
              }
            }
          }
        }
        if (notExists) {
          this.quickFiltersSelection.push(null);
        }
        this.quickFiltersOptions.push({});
        //
      }

      //
      //
    },
    getDefUserViewFilter() {
      return new Promise(async (resolve, reject) => {
        this.filtersService
          .getDefUserViewFilter(this.dbView)
          .then(data => resolve(data))
          .catch(err => {
            this.savedFilter = {};

            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting default user view filter.",
            //   life: 5000,
            // })
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "defUserViewFilter/{dbView}"'
            });
            reject();
          });
      });
    },
    getUserViewFiltersByHard() {
      this.filtersService
        .getUserViewFiltersByHard(this.dbView)
        .then(data => {
          //
          let obj = { ...this.savedFilter };

          this.savedFilters = data;
          if (obj && obj.id) {
            this.savedFilter = data.find(a => {
              if (a && a.id === obj.id) {
                return true;
              }
            });
          }
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer user filters",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "userViewFilters/{dbView}"'
          });
        });
    },
    getUserViewFilters() {
      this.filtersService
        .getUserViewFilters(this.dbView)
        .then(data => {
          this.savedFilters = data;
        })
        .catch(err => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "userViewFilters/{dbView}"'
          });
        });
    },
    setupColumns() {
      if (
        this.colSelectedFields &&
        this.colSelectedFields[0] &&
        this.columnSelectionDialog
      ) {
        this.reloadColumnSelectionComponent++;
      }

      let a = [];
      this.colSelectedFields.forEach(b => {
        //
        let c = a.find(d => d.dbField === b.dbField.dbField);
        //
        if (!a[b.colOrder - 1] && !c) {
          a[b.colOrder - 1] = {
            ...b.dbField,
            defWidth: b.width
          };
        }
      });

      if (a.length) {
        this.colSelectedFieldsForTable = a;
      }
    },
    getColumnSelectionByHard() {
      this.filtersService
        .getColumnSelectionByHard(this.dbView)
        .then(data => {
          this.colSelectedFields = data;
        })
        .catch(err => {
          if (err.response.status === 500) {
            // Default view

            this.defaultView = true;
          }

          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "currentUserViewFields/{dbView}"'
          });
        });
    },
    getColumnSelection() {
      this.filtersService
        .getColumnSelection(this.dbView)
        .then(data => {
          this.colSelectedFields = data;
        })
        .catch(err => {
          if (err.response.status === 500) {
            // Default view

            this.defaultView = true;
          }

          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "currentUserViewFields/{dbView}"'
          });
        });
    },
    getDBViewFields() {
      this.filtersService
        .getDBViewFields(this.dbView)
        .then(data => (this.dbViewFields = data))
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer DB view fields",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          });
        });
    },
    isEmpty() {
      return !(
        this.quickFiltersSelection.every(
          element => element === undefined || element === null
        ) &&
        this.datesFrom.every(
          element => element === undefined || element === null
        ) &&
        this.datesTo.every(element => element === undefined || element === null)
      );
    },
    getBadgeForQuickFilters() {
      let count = 0;
      for (let i = 0; i < this.quickFiltersSelection.length; i++) {
        if (
          this.quickFiltersSelection[i] ||
          this.datesFrom[i] ||
          this.datesTo[i] ||
          this.datesFrom[i] === 0 ||
          this.datesTo[i] === 0
        ) {
          if (Array.isArray(this.quickFiltersSelection[i])) {
            if (this.quickFiltersSelection[i].length > 0) count++;
          } else {
            count++;
          }
        }
      }
      return count;
    },
    getClassForQuickFiltersButon() {
      if (this.isEmpty()) {
        return "p-button-success";
      } else {
        return "p-button-info";
      }
    },
    getClassForQuickFiltersDiv() {
      if (this.isEmpty()) {
        return "greenBackground";
      } else {
        return "defaultBackground";
      }
    },
    isQuickFilterable(index) {
      //
      return this.dbViewFieldsForQuickFilters[index] &&
        this.dbViewFieldsForQuickFilters[index].quickFilter
        ? this.dbViewFieldsForQuickFilters[index].quickFilter
        : false;
    },
    getFieldType(index) {
      //
      //
      //
      return this.dbViewFieldsForQuickFilters[index] &&
        this.dbViewFieldsForQuickFilters[index].fieldType
        ? this.dbViewFieldsForQuickFilters[index].fieldType
        : "";
    },
    setSelection({ value, index }) {
      this.quickFiltersSelection[index] = value;
    },
    useAutoComplete(index) {
      //
      return this.dbViewFieldsForQuickFilters[index]
        ? this.dbViewFieldsForQuickFilters[index].filterAutocomplete
        : false;
    },
    showDropdown(index) {
      //
      return this.dbViewFieldsForQuickFilters[index]
        ? this.dbViewFieldsForQuickFilters[index].filterDropdown
        : false;
    },
    isForceSelection(index) {
      return this.dbViewFieldsForQuickFilters[index]
        ? !this.dbViewFieldsForQuickFilters[index].filterAllowStartWith
        : false;
    },
    getOptions(index) {
      var branchIndex = 2;
      var branch = this.$store.getters["auth/getMyProfile"].defBranch;

      if (branchIndex == index) {
        let permission = this.myPermissions.find(
          a => a.permission.permissionCode === "ViewCustomers"
        );

        if (permission) {
          if (permission.permissionLevel == 5) {
            if (!branch) {
              this.noBranchHandle();
              return;
            }
            if (this.quickFiltersOptions[index].length > 0)
              this.quickFiltersOptions[index] = this.quickFiltersOptions[
                index
              ].filter(qf => qf.id === branch.id);
            this.quickFiltersSelection[index] = [branch];
            return this.quickFiltersOptions[index];
          }
        }
      } else if (index == 27) {
        let permission = this.myPermissions.find(
          a => a.permission.permissionCode === "ViewCustomers"
        );

        if (permission) {
          if (permission.permissionLevel == 4) {
            // global user
            return this.quickFiltersOptions[index];
          }
        }
      }

      return Array.isArray(this.quickFiltersOptions[index])
        ? this.quickFiltersOptions[index]
        : [];
    },
    noBranchHandle() {
      this.$router.push({ name: "dashboard", query: { toast: "yes" } });
    },
    getDataKey(data) {
      return data ? data.dbIdField : null;
    },
    getOptionLabel(data, index) {
      //
      let a = data ? data.dbField : "",
        b = this.getOptions(index);
      //
      if (b && b[0] && data.dbNameField && (data.dbNameField in b[0])) {
        a = data ? data.dbNameField : "";
        return a;
      } else {
        a = data ? data.dbField.split(".").slice(-1) : "";
        return a[0];
      }
    },
    showDateRanges(index) {
      //
      if (
        this.quickFiltersSelection[index] &&
        this.quickFiltersSelection[index].dateModifierFunc === "custom"
      ) {
        return true;
      } else {
        return false;
      }
    },
    clearQuickFiltersSelections() {
      for (let i = 0; i < this.quickFiltersSelection.length; i++) {
        /*
        Here, we are resetting all the quickFilters except the filter with default values which have index 27 and 2 respectively
        */
        if (i == 2) {
          let permission = this.myPermissions.find(
            a => a.permission.permissionCode === "ViewCustomers"
          );

          if (permission) {
            if (permission.permissionLevel != 5) {
              // global user
              this.quickFiltersSelection[i] = null;
              this.datesFrom[i] = null;
              this.datesTo[i] = null;
            }
          }
        } else {
          this.quickFiltersSelection[i] = null;
          this.datesFrom[i] = null;
          this.datesTo[i] = null;
        }
      }
      this.quickFiltersDivKey++;
    },
    clearQuickFilter() {
      this.quickFilterDialog = false;
      this.clearQuickFiltersSelections();

      this.getDataFromSource();
    },
    editSelectedFilter() {
      this.filterToEdit = { ...this.savedFilter };
      this.filterFormDialog = true;
    },
    newFilter() {
      this.filterToEdit = {};
      this.filterFormDialog = true;
    },
    reload() {
      this.forceReload = true;
      this.setupComponentData(0);
    },
    updateDefaultFilter() {
      this.filtersService
        .getDefUserViewFilterByHard(this.dbView)
        .then(data => {})
        .catch(error => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while updating default filter.",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "defUserViewFilter/{dbView}"'
          });
        });
    },
    filterSaved() {
      this.filterFormDialog = false;
      this.getUserViewFiltersByHard();
      this.updateDefaultFilter();

      this.filterToEdit = {};

      // this.setupComponentData(0)
    },
    colSaved() {
      this.columnSelectionDialog = false;

      this.getColumnSelectionByHard();
      this.getDBViewFields();
    },
    openColumnsSelection() {
      this.columnSelectionDialog = true;
      this.reloadColumnSelectionComponent++;
    },
    editCustomer(customer) {
      let permission = this.myPermissions.find(
        a => a.permission.permissionCode === "EditCustFields"
      );
      this.customer = { ...customer };
      this.setupFieldPermissions();
      if (!this.disabledArr.includes("country"))
        this.disabledArr.push("country");
      if (
        permission &&
        permission.permissionLevel &&
        permission.permissionLevel !== 0 &&
        !this.keyContactIncludedInNonAllowFields
      )
        if (this.disabledArr.includes("keyContact"))
          this.disabledArr = this.disabledArr.filter(
            field => field !== "keyContact"
          );
      this.customerDialog = true;
    },
    openNew() {
      let permission = this.myPermissions.find(
        a => a.permission.permissionCode === "addNewCustomer"
      );
      if (permission) {
        if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new Customer",
            life: 5000
          });
        } else if (permission.permissionLevel === 1) {
          this.customer = {};
          this.disabledArr = ["keyContact", "country"];
          this.open = true;
          this.customerDialog = true;
        }
      }
    },
    saved({ customer, duplicates }) {
      this.customerDialog = false;
      this.customer = {};

      if (duplicates && duplicates.length) {
        this.duplicates = duplicates;
        this.customer = customer;
        this.displayDuplicateMessage = true;
      } else {
        this.customers.push(customer);
        this.reload();
      }
    },
    sendDuplicate() {
      customerConf(this, "Customers.vue");
    },
    deleteSavedFilter() {
      if (this.savedFilter && this.savedFilter.id) {
        this.deleteRequesting = true;

        this.filtersService
          .deleteFilter(this.savedFilter.id)
          .then(data => {
            this.deleteRequesting = false;
            this.deleteSavedFilterWarning = false;
            this.getUserViewFiltersByHard();
          })
          .catch(error => {
            this.deleteRequesting = false;
            this.$toast.add({
              severity: "error",
              summary: "Unable to delete.",
              detail: "Got some error while deleting this filter.",
              life: 5000
            });
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "A filter is required",
          detail: "Please select a saved filter first.",
          life: 5000
        });
      }
    },
    openCustomerForApproval(customer) {
      this.selectedRow = customer;
      this.customerForApproval = {};
      this.assignToCustomerDialog = true;
    },
    setCustomerForApproval({ value, index }) {
      //
      this.customerForApproval = value;
    },
    assignCustomer() {
      this.submitted = true;
      this.sendingRequest = true;
      if (
        this.selectedRow &&
        this.selectedRow.customerId &&
        this.customerForApproval &&
        this.customerForApproval.customerId
      ) {
        this.customerService
          .assignCustomer(
            this.selectedRow.customerId,
            this.customerForApproval.customerId
          )
          .then(data => {
            this.sendingRequest = false;
            this.assignToCustomerDialog = false;
          })
          .catch(error => {
            this.sendingRequest = false;
            this.assignToCustomerDialog = false;

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while assigning customer.",
              life: 5000
            });
          });
      } else {
        this.sendingRequest = false;
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          let a = v,
            parts = j.split(".");
          parts.forEach(part => {
            if (a) {
              a = a[part];
            }
          });
          if (a === true) {
            return "Yes";
          } else if (a === false) {
            return "No";
          } else {
            return a;
          }
        })
      );
    },
    exportData() {
      let savedFilter1 = 0,
        quickFilters = {};

      if (this.savedFilter && this.savedFilter.id) {
        savedFilter1 = this.savedFilter.id;
      }
      if (
        !(
          this.quickFiltersSelection.every(
            element => element === undefined || element === null
          ) &&
          this.datesFrom.every(
            element => element === undefined || element === null
          ) &&
          this.datesTo.every(
            element => element === undefined || element === null
          )
        )
      ) {
        if (this.dbViewFieldsForQuickFilters.length) {
          for (let i = 0; i < this.dbViewFieldsForQuickFilters.length; i++) {
            try {
              if (this.dbViewFieldsForQuickFilters[i].quickFilter) {
                //

                let a = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(0)[0];
                let b = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(-1)[0];

                if (this.quickFiltersSelection[i]) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Date"
                  ) {
                    //

                    if (
                      this.quickFiltersSelection[i].dateModifierFunc ===
                      "custom"
                    ) {
                      //
                      if (this.datesFrom[i]) {
                        try {
                          quickFilters[`${a}From`] = moment(
                            this.datesFrom[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}From`] = this.datesFrom[i];
                        }
                      }
                      if (this.datesTo[i]) {
                        try {
                          quickFilters[`${a}To`] = moment(
                            this.datesTo[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}To`] = this.datesTo[i];
                        }
                      }
                    } else {
                      quickFilters[a] = this.quickFiltersSelection[
                        i
                      ].dateModifierFunc;
                    }
                  } else {
                    //
                    if (this.quickFiltersSelection[i][b] === "Yes") {
                      quickFilters[a] = true;
                    } else if (this.quickFiltersSelection[i][b] === "No") {
                      quickFilters[a] = false;
                    } else if (
                      this.dbViewFieldsForQuickFilters[i].lovEP &&
                      this.dbViewFieldsForQuickFilters[i].lovEP.substr(0, 1) ===
                        "*"
                    ) {
                      quickFilters[a] = this.quickFiltersSelection[i][b];
                    } else {
                      if (typeof this.quickFiltersSelection[i] === "string") {
                        quickFilters[a] = this.quickFiltersSelection[i];
                      } else {
                        if (this.quickFiltersSelection[i]?.length > 0)
                          quickFilters[a] = this.quickFiltersSelection[i]
                            .map(item => {
                              return item[
                                this.dbViewFieldsForQuickFilters[i].dbIdField
                              ];
                            })
                            .join(",");
                      }
                    }
                  }
                } else if (
                  !(
                    this.datesFrom[i] === undefined ||
                    this.datesFrom[i] === null ||
                    this.datesTo[i] === undefined ||
                    this.datesTo[i] === null
                  )
                ) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType ===
                      "Currency" ||
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Number"
                  ) {
                    quickFilters[`${a}From`] = this.datesFrom[i];
                    quickFilters[`${a}To`] = this.datesTo[i];
                  }
                }
              }
            } catch (e) {
              continue;
            }
          }
        } else {
          cancelRequest = true;
        }
      }

      let searchQuery = "*";
      if (this.searchText) {
        searchQuery = this.searchText;
      }

      quickFilters.searchText = searchQuery;

      this.checkPermissions();
      if (savedFilter1 || Object.keys(quickFilters).length > 1) {
        if (this.exportFilterToExcel === false) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You don't have permission to export this data",
            life: 5000
          });
          return;
        }
      } else if (this.exportAllToExcel === false) {
        this.$toast.add({
          severity: "error",
          summary: "Not allowed",
          detail: "You don't have permission to export this data",
          life: 5000
        });
        return;
      }

      import("@/service/Export2Excel").then(excel => {
        this.makingExport = true;
        this.customerService
          .getCustomers2(savedFilter1, 1, 100000, 0, 0, "*", quickFilters)
          .then(response => {
            //

            if (response.data) {
              const tHeader = [
                "Id",
                "TAS Code",
                "Customer Name",
                "House",
                "Street",
                "Sub Area",
                "City/Town",
                "Location",
                "Post Code",
                "Phone No.",
                "Branch Code",
                "Is Main Branch?",
                "Branch Sales Exec",
                "Customer Type",
                "Industry Type",
                "Key Contact",
                "Parent Customer",
                "Region",
                "Status",
                "Approval Required?",
                "Created By",
                "Date Created",
                "Updated By",
                "Date Updated"
              ];
              const filterVal = [
                "customerId",
                "custCode",
                "custName",
                "address1",
                "address2",
                "address3",
                "address4",
                "custLocation",
                "postCode",
                "phoneNo",
                "branchCode",
                "isMainBranch",
                "branchSalesExecName",
                "customerTypeName",
                "industryTypeDesc",
                "keyContactName",
                "parentCustomer",
                "regionName",
                "status",
                "requireApproval",
                "createdBy",
                "dateCreated",
                "updatedBy",
                "dateUpdated"
              ];
              const data = this.formatJson(filterVal, response.data);
              //
              let a = new Date(),
                date =
                  a.getDate() +
                  "_" +
                  a.getMonth() +
                  1 +
                  "_" +
                  a.getFullYear() +
                  "-" +
                  a.getHours() +
                  "_" +
                  a.getMinutes() +
                  "_" +
                  a.getSeconds();

              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: "Customers" + "-" + date,
                autoWidth: true,
                bookType: "xlsx"
              });
            }

            this.makingExport = false;
          })
          .catch(err => {
            this.makingExport = false;

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: `Error while getting enquiries for exporting(0/1/100000/0/0/*)`,
              life: 5000
            });
          });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.greenBackground {
  background-color: #5c9434;
  width: 83px;
}

.defaultBackground {
  // background-color: #2494f4;
  background-color: #248cc4;
  width: 50px;
}
</style>
